export default __webpack_public_path__ + "static/media/section4-dataprocessing.0dac8220.jpeg";